import {
  SETVOICE,
  HIGHLIGHTVOICEKEY,
  SET_SLIDER_VALUE,
  SETCONSISTENCY,
  SET_MIDI_FLAG,
  SET_NOTE_MIDI_NUM,
  SET_MUSIC_THEORY_FORMULA,
  SET_WIDGET_STARTED,
  SET_TONES_MT,
  SET_GHOST_TONES_MT,
  SET_SHOW_GHOST,
  SET_SONGS_ARRAY,
  SET_ALLNOTES,
  SET_NOTES,
  SET_PIANO_LABELS,
  SET_LABELS,
  SET_SONG_MODAL,
  SET_BUFFER_LOADING,
  SET_AUTO_LABEL,
  SET_APPLY_GHOST,
  SET_CURRENT_SONG,
  SET_CURRENT_SONG_NAME,
  SET_CURRENT_SONG_INDEX,
  SET_SCALE_EDITING,
  SET_USER_GHOST,
  SET_CURRENT_SECTION_NAME,
  SET_OPEN_SECTION_MODAL,
  SET_BASE_NOTE,
  SET_MUSIC_THEORY_MIDI_NUMS,
  SET_WRONG_MIC_INPUT,
  SET_WRONG_MIDI_INPUT,
  SET_USER_SELECTED_LABELS,
  SET_CUSTOM_VOCAL_TONE,
  SET_SHOW_RANGE,
  SET_DEFAULT_MT,
  SET_SUSTAIN_PEDAL,
  SET_SUSTAINED_NOTES,
  SET_SUSTAIN_PEDAL_NTTOGGLE,
} from "./actions";
import { MidiNumbers } from "../ImportPiano";
import { ALLNOTES, NOTES } from "../helpers/pianoHelpers";
import { standardLabels } from "../helpers/keyLabelsMapper";

const initialState = {
  //initial toggle for sustain NT Pedal
  sustainPedalNTToggle: true,
  //below 4 states for voice key highlight
  highlightkeyNumberForVoice: [],
  voiceDetect: false,
  sliderValue: 0.5,
  voiceConsistency: false,
  enableMidiFlag: true,
  widgetStarted: false,
  showGhost: true,
  openNewSongModal: false,
  bufferLoading: false,
  sustainPedal: false,
  autoLabel: true,
  applyGhost: true,
  currentSong: "",
  currentSongName: "",
  currentSongIndex: "",
  scaleEditing: false,
  userGhost: true,
  openNewSectionModal: false,
  showWrongMidiInput: true,
  showWrongMicInput: true,
  currentSectionName: "",
  userSelectedLabels: false,
  showRange: false,

  // below 3 states are config for App and SoundProvider
  config: {
    instrumentName: "acoustic_grand_piano",
    noteRange: {
      first: MidiNumbers.fromNote("a0"),
      last: MidiNumbers.fromNote("c8"),
      // first: MidiNumbers.fromNote("c2"),
      // last: MidiNumbers.fromNote("b6"),
    },
    keyboardShortcutOffset: 0,
  },
  audioContext: new (window.AudioContext || window.webkitAudioContext)(),
  soundfontHostname: "https://d1pzp51pvbm36p.cloudfront.net",
  // below 2 states for sound provider only
  format: "mp3",
  soundfont: "MusyngKite",

  notesMidiNum: {
    lowestVoiceNote: 0,
    bridgeVoiceNote: [],
    highestVoiceNote: 0,
  },
  musicTheoryFormula: "",
  tonesMT: {
    baseNote: 3,
    tones: 0,
    modesOfScales: 0,
    modesOfScalesValues: {},
  },
  ghostTonesMT: {
    baseNote: 3,
    tones: 0,
    modesOfScales: 0,
    modesOfScalesValues: {},
  },
  defaultMt: {
    baseNote: 3,
    tones: 2,
    modesOfScales: 0,
    modesOfScalesValues: {},
  },
  songsArray: JSON.parse(localStorage.getItem("songsArray")),
  customVocalTone: JSON.parse(localStorage.getItem("customVocalTone")) || [
    "D",
    "A",
    "A",
    3,
    4,
    5,
  ],
  
  notes: NOTES,
  allNotes: ALLNOTES,
  standardLabels: standardLabels,
  selectedLabel: "No Labels",
  baseNote: [
    "A",
    "A♯",
    "B",
    "C",
    "C♯",
    "D",
    "D♯",
    "E",
    "F",
    "F♯",
    "G",
    "G♯",
    "A",
    "A♯",
    "B",
    "C",
    "C♯",
    "D",
    "D♯",
    "E",
    "F",
    "F♯",
    "G",
    "G♯",
  ],
  musicTheoryMidiNums: [],
};

const pianoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETVOICE:
      return {
        ...state,
        voiceDetect: action.payload,
      };
    case SETCONSISTENCY:
      return {
        ...state,
        voiceConsistency: action.payload,
      };
    case HIGHLIGHTVOICEKEY:
      return {
        ...state,
        highlightkeyNumberForVoice: action.payload,
      };
    case SET_SLIDER_VALUE:
      return { ...state, sliderValue: action.payload };
    case SET_MIDI_FLAG:
      return { ...state, enableMidiFlag: action.payload };
    case SET_NOTE_MIDI_NUM:
      return { ...state, notesMidiNum: action.payload };
    case SET_MUSIC_THEORY_FORMULA:
      return { ...state, musicTheoryFormula: action.payload };
    case SET_WIDGET_STARTED:
      return { ...state, widgetStarted: action.payload };
    case SET_TONES_MT:
      return { ...state, tonesMT: action.payload };
    case SET_GHOST_TONES_MT:
      return { ...state, ghostTonesMT: action.payload };
    case SET_APPLY_GHOST:
      return { ...state, applyGhost: action.payload };
    case SET_SHOW_GHOST:
      return { ...state, showGhost: action.payload };
    case SET_SONGS_ARRAY:
      return { ...state, songsArray: action.payload };
    case SET_NOTES:
      return { ...state, notes: action.payload };
    case SET_ALLNOTES:
      return { ...state, allNotes: action.payload };
    case SET_PIANO_LABELS:
      return { ...state, standardLabels: action.payload };
    case SET_LABELS:
      return { ...state, selectedLabel: action.payload };
    case SET_SONG_MODAL:
      return { ...state, openNewSongModal: action.payload };
    case SET_BUFFER_LOADING:
      return { ...state, bufferLoading: action.payload };
    case SET_AUTO_LABEL:
      return { ...state, autoLabel: action.payload };
    case SET_CURRENT_SONG:
      return { ...state, currentSong: action.payload };
    case SET_CURRENT_SONG_NAME:
      return { ...state, currentSongName: action.payload };
    case SET_CURRENT_SONG_INDEX:
      return { ...state, currentSongIndex: action.payload };
    case SET_SCALE_EDITING:
      return { ...state, scaleEditing: action.payload };
    case SET_USER_GHOST:
      return { ...state, userGhost: action.payload };
    case SET_OPEN_SECTION_MODAL:
      return { ...state, openNewSectionModal: action.payload };
    case SET_CURRENT_SECTION_NAME:
      return { ...state, currentSectionName: action.payload };
    case SET_BASE_NOTE:
      return { ...state, baseNote: action.payload };
    case SET_MUSIC_THEORY_MIDI_NUMS:
      return { ...state, musicTheoryMidiNums: action.payload };
    case SET_WRONG_MIC_INPUT:
      return { ...state, showWrongMicInput: action.payload };
    case SET_WRONG_MIDI_INPUT:
      return { ...state, showWrongMidiInput: action.payload };
    case SET_USER_SELECTED_LABELS:
      return { ...state, userSelectedLabels: action.payload };
    case SET_CUSTOM_VOCAL_TONE:
      return { ...state, customVocalTone: action.payload };
    case SET_SHOW_RANGE:
      return { ...state, showRange: action.payload };
    case SET_DEFAULT_MT:
      return { ...state, defaultMt: action.payload };
    case SET_SUSTAIN_PEDAL:
      return { ...state, sustainPedal: action.payload };
    case SET_SUSTAINED_NOTES:
      return { ...state, sustainedNotes: action.payload };
    case SET_SUSTAIN_PEDAL_NTTOGGLE:
      return { ...state, sustainPedalNTToggle: action.payload };
    default:
      return state;
  }
};

export default pianoReducer;
